function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.5466 1.36184L17.0162 0.191082C16.8985 -0.0687043 16.72 -0.0628507 16.6196 0.20409L15.8159 2.33923C15.6606 2.75165 15.7007 2.84988 16.1185 3.00714L18.2536 3.81084C18.5206 3.91132 18.6426 3.78103 18.5249 3.52124L18.062 2.4994C18.0387 2.46137 18.0176 2.42678 17.9983 2.39489C18.0938 2.38888 18.1897 2.3686 18.28 2.33616C18.3294 2.31841 18.3796 2.30279 18.4306 2.28936C18.6735 2.22528 18.9271 2.21239 19.1753 2.25149C19.4235 2.2906 19.6608 2.38085 19.8723 2.51653C20.0837 2.65221 20.2647 2.83035 20.4037 3.03965C20.5427 3.24896 20.6366 3.48486 20.6796 3.7324C20.7226 3.97994 20.7137 4.23371 20.6534 4.47762C20.5932 4.72153 20.4829 4.95026 20.3296 5.1493C20.2974 5.19102 20.2635 5.23125 20.228 5.26989C20.0063 5.51114 19.8902 5.86694 20.0474 6.15448C20.2045 6.44202 20.5701 6.55167 20.8212 6.34106C20.9867 6.20222 21.1371 6.04553 21.2697 5.87347C21.5233 5.54418 21.7058 5.16577 21.8055 4.76223C21.9052 4.3587 21.9199 3.93886 21.8488 3.52932C21.7777 3.11979 21.6222 2.72951 21.3923 2.38323C21.1623 2.03695 20.863 1.74223 20.5131 1.51776C20.1633 1.29329 19.7706 1.14398 19.36 1.07928C18.9494 1.01458 18.5298 1.03591 18.1279 1.14193C17.9265 1.19505 17.7317 1.26886 17.5466 1.36184Z",
  fill: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.43945 14.0359L6.86123 16.48L11.253 14.0502",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.86035 20.8132V16.4751",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6726 14.8632V17.5704C11.6726 18.6561 11.3677 19.032 10.917 19.3735C10.0852 20.0039 8.97296 20.2029 7.89683 20.7702C7.32595 21.0763 6.39451 21.0763 5.82364 20.7702L3.14953 19.3544C2.5436 19.034 2.04785 18.2304 2.04785 17.5704V14.8632C2.04785 14.2032 2.5436 13.3996 3.14953 13.0792L5.82364 11.6634C6.39451 11.3573 7.32595 11.3573 7.89683 11.6634L10.5709 13.0792C11.1769 13.3996 11.6726 14.2032 11.6726 14.8632Z",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7188 14.0359L17.1405 16.48L21.5323 14.0502",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1396 20.8132V16.4751",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9519 14.8632V17.5704C21.9519 18.6561 21.647 19.032 21.1963 19.3735C20.3645 20.0039 19.2523 20.2029 18.1761 20.7702C17.6052 21.0763 16.6738 21.0763 16.1029 20.7702L13.4288 19.3544C12.8229 19.034 12.3271 18.2304 12.3271 17.5704V14.8632C12.3271 14.2032 12.8229 13.3996 13.4288 13.0792L16.1029 11.6634C16.6738 11.3573 17.6052 11.3573 18.1761 11.6634L20.8502 13.0792C21.4562 13.3996 21.9519 14.2032 21.9519 14.8632Z",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0044 8.08835V11.1608C17.0044 12.3929 16.6738 12.8195 16.1853 13.2072C15.2836 13.9226 14.078 14.1484 12.9115 14.7923C12.2927 15.1397 11.283 15.1397 10.6642 14.7923L7.76549 13.1855C7.10868 12.8218 6.57129 11.9099 6.57129 11.1608V8.08835C6.57129 7.33925 7.10868 6.42731 7.76549 6.06362L10.6642 4.45685C11.283 4.10944 12.2927 4.10944 12.9115 4.45685L15.8102 6.06362C16.467 6.42731 17.0044 7.33925 17.0044 8.08835Z",
  fill: "white",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99609 7.14941L11.7892 9.92324L16.5498 7.16568",
  fill: "white"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99609 7.14941L11.7892 9.92324L16.5498 7.16568",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7881 14.8412V9.91772",
  stroke: "#00BB77",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgGroupOfferingIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupOfferingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group-offering-icon.a1a390e8.svg";
export { ForwardRef as ReactComponent };